import { createSelector } from 'reselect';
import { getProp } from '../../utilities';
import { sectorsOfAllConnectionsByIdSelector } from '../Connections/selectors';
import { userDetailSelector } from '../Login/selectors';
import { summarySelector } from '../Summary/selectors';

const stepperDetailDomainSelector = state => state.stepper;
export const ticketIdSelector = state => state.ticketId;

export const seatingsListSelector = createSelector(
  stepperDetailDomainSelector,
  sectorsOfAllConnectionsByIdSelector,
  (substate, sectorsById) => {
    const seatings = getProp(substate, ['stepParams', 'reservations'], []);
    return Object.keys(seatings).map(seat => {
      const toReturn = sectorsById[seat];
      if (toReturn) {
        const bussesByBusId = seatings[seat];
        const busses = Object.keys(bussesByBusId);
        let busId = null;
        if (busses.length > 0) {
          busId = busses.find(_busId => {
            const bus = bussesByBusId[_busId];
            const foundBusId = getProp(bus, [0], null);
            if (foundBusId) {
              return true;
            }
            return false;
          });

          if (busId) {
            toReturn.busInfo = getProp(sectorsById[seat], ['busses'], []).find(
              b => b.id_bus === busId,
            );
          }
        }
        if (seatings[seat][busId].length > 0) {
          // ak mam miestenku pre dany autobus v danom sektore
          toReturn.seatings = seatings[seat][busId];
        }
        return toReturn;
      }
      return {};
    });
  },
);

export const finalFormatDataSelector = createSelector(
  summarySelector,
  stepperDetailDomainSelector,
  userDetailSelector,
  (substate, stepper, user) => {
    let a = 0;
    const reservations = getProp(stepper, ['stepParams', 'reservations']);
    const passengers = getProp(stepper, ['stepParams', 'passengers']);
    const pass = getProp(passengers, [0, 'pass']);
    let i = 0;

    const data = substate.reduce((p, oneTicket) => {
      const ticket = getProp(oneTicket, ['ticket']);

      const idDps1 = parseInt(getProp(ticket, ['id_dps1']), 0);
      const seatsByBusId1 = reservations[idDps1] || {};
      const busses1 = Object.keys(seatsByBusId1);
      const busId1 = busses1.find(_busId => {
        const bus = seatsByBusId1[_busId];
        if (Array.isArray(bus) && bus.length > 0) {
          return true;
        }
        return false;
      });

      const idDps2 = parseInt(getProp(ticket, ['id_dps2']), 0);
      const seatsByBusId2 = reservations[idDps2] || {};
      const busses2 = Object.keys(seatsByBusId2);
      const busId2 = busses2.find(_busId => {
        const bus = seatsByBusId2[_busId];
        if (Array.isArray(bus) && bus.length > 0) {
          return true;
        }
        return false;
      });

      return {
        ...p,
        ...getProp(oneTicket, ['persons'], []).reduce((prev, person) => {
          a++;
          const obj = {
            [`ticket${a}_tt`]: getProp(ticket, ['tt']),
            [`ticket${a}_price`]: parseFloat(
              getProp(person, ['tarrif', 'price_total']),
            ),
            [`ticket${a}_id_tarrif`]: parseInt(
              getProp(person, ['tarrif', 'id_tarrif']),
              0,
            ),
            [`ticket${a}_surname`]: getProp(person, ['surname']),
            [`ticket${a}_username`]: getProp(person, ['name']),
            [`ticket${a}_phone`]: getProp(person, ['phone']),
            [`ticket${a}_id_dps1`]: parseInt(getProp(ticket, ['id_dps1']), 0),
            [`ticket${a}_id_bus1`]: parseInt(busId1, 0),
            [`ticket${a}_seat1`]: getProp(reservations, [
              getProp(ticket, ['id_dps1']),
              busId1,
              i,
            ]),
            [`ticket${a}_id_prejazd1`]: parseInt(
              getProp(ticket, ['id_prejazd1']),
              0,
            ),
            [`ticket${a}_price1`]: parseFloat(
              getProp(person, ['tarrif', 'price1']),
              0,
            ),
          };
          if (getProp(ticket, ['tt']) === 'R') {
            obj[`ticket${a}_id_dps2`] = parseInt(
              getProp(ticket, ['id_dps2']),
              0,
            );
            obj[`ticket${a}_id_bus2`] = parseInt(busId2, 0);
            obj[`ticket${a}_seat2`] = getProp(reservations, [
              getProp(ticket, ['id_dps2']),
              busId2,
              i,
            ]);
            obj[`ticket${a}_id_prejazd2`] = parseInt(
              getProp(ticket, ['id_prejazd2']),
              0,
            );
            obj[`ticket${a}_price2`] = parseFloat(
              getProp(person, ['tarrif', 'price2']),
            );
          } else if (getProp(ticket, ['tt']) === 'O') {
            obj[`ticket${a}_id_prejazd2`] = parseInt(
              getProp(ticket, ['id_prejazd1']),
              0,
            );
            obj[`ticket${a}_price2`] = parseFloat(
              getProp(person, ['tarrif', 'price1']),
            );
          }
          i++;

          return {
            ...prev,
            ...obj,
          };
        }, {}),
      };
    }, {});
    if (pass) {
      data.registration = 1;
      data.registrationPass = pass;
    }
    return data;
  },
);

export const reservationsSelector = createSelector(
  stepperDetailDomainSelector,
  stepper => {
    return getProp(stepper, ['stepParams', 'reservations'], []);
  },
);



// WEBPACK FOOTER //
// ./src/containers/SummaryPage/selectors.js